import React from 'react';
import { Header } from '@/components/layout';
import { AnalysisLoadingAnimation } from '@/components/ui/AnalysisLoadingAnimation';

interface ProcessingViewProps {
  analysisName?: string;
}

export const ProcessingView: React.FC<ProcessingViewProps> = ({
  analysisName
}) => (
  <>
    <div>
      <Header />
    </div>
    <AnalysisLoadingAnimation analysisName={analysisName} />
  </>
);
